"use client";

import type { BillingInfoInputDto, CartOutputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CART_ACTIVE_FILTER } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useServicesStore } from "@/stores/useServicesStore";

export const billingAddressMutationKey = ["billingAddress"] as const;

export function useBillingAddressMutation() {
  const cartClient = useServicesStore(state => state.cartClient);
  const cartId = useGlobalStore(state => state.cartId);
  const queryClient = useQueryClient();

  return useMutation<CartOutputDto, Error, BillingInfoInputDto>({
    mutationKey: billingAddressMutationKey,
    mutationFn: async billingInfo => {
      if (!cartClient) throw new Error("Cart client is not available.");
      if (!cartId) throw new Error("Cart id is not available.");
      return await cartClient.postBillingAddress(cartId, billingInfo);
    },
    onSuccess: cart => {
      queryClient.setQueriesData<CartOutputDto | null>(CART_ACTIVE_FILTER, cart);
    },
  });
}
